var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _path61, _path62, _path63, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingPageImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 376,
    viewBox: "0 0 478 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3853_31923)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1372 375.249H187.484C197.804 375.249 206.17 366.883 206.17 356.563L206.17 19.1373C206.17 8.81754 197.804 0.45166 187.484 0.45166H19.1372C8.81741 0.45166 0.451569 8.81754 0.451569 19.1373L0.451569 356.563C0.451569 366.883 8.81741 375.249 19.1372 375.249Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.705 363.35H181.916C189.737 363.35 196.077 357.01 196.077 349.189L196.077 25.477C196.077 17.6561 189.737 11.316 181.916 11.316H24.705C16.8841 11.316 10.544 17.6561 10.544 25.477L10.544 349.189C10.544 357.01 16.8841 363.35 24.705 363.35Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.586 21.9189H81.7012",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.817 375.249H458.164C468.484 375.249 476.85 366.883 476.85 356.563L476.85 19.1373C476.85 8.81754 468.484 0.45166 458.164 0.45166H289.817C279.497 0.45166 271.132 8.81754 271.132 19.1373L271.132 356.563C271.132 366.883 279.497 375.249 289.817 375.249Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.385 363.35H452.597C460.417 363.35 466.758 357.01 466.758 349.189L466.758 25.477C466.758 17.6561 460.417 11.316 452.597 11.316H295.385C287.564 11.316 281.224 17.6561 281.224 25.477V349.189C281.224 357.01 287.564 363.35 295.385 363.35Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.27 21.9189H352.386",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.234 102.911C180.002 82.5413 210.067 70.1594 243.022 70.1594C275.977 70.1594 306.909 82.907 329.794 103.805",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336.256 287.623C312.811 312.246 279.707 327.595 243.022 327.595C206.337 327.595 172.072 311.705 148.56 286.313",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M281.938 198.313H243.808V236.379H281.938V198.313Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.246 196.533H227.181C238.646 196.533 249.976 199.044 260.366 203.88L250.861 207.384L269.181 239.098C272.256 244.426 266.124 250.545 261.568 246.643C261.464 246.553 261.36 246.463 261.256 246.363C262.38 251.859 254.884 253.272 251.087 248.477C252.116 253.507 245.275 256.022 240.692 250.635C242.363 256.415 234.207 258.691 230.478 252.757C226.54 246.49 214.438 225.84 214.438 225.84H203.56L204.246 196.533Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.89 228.482L215.449 233.842C213.865 234.524 212.022 233.797 211.336 232.212L210.505 230.292C209.819 228.707 210.55 226.865 212.14 226.179L224.58 220.819C226.165 220.137 228.007 220.864 228.694 222.449L229.525 224.368C230.211 225.953 229.48 227.795 227.89 228.482Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.076 235.58L219.635 240.94C218.05 241.622 216.208 240.895 215.522 239.31L214.691 237.391C214.004 235.806 214.736 233.963 216.326 233.277L228.766 227.917C230.351 227.235 232.193 227.962 232.88 229.547L233.711 231.466C234.397 233.051 233.666 234.894 232.076 235.58Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M236.872 242.683L224.431 248.043C222.846 248.725 221.004 247.998 220.317 246.413L219.486 244.494C218.8 242.909 219.532 241.067 221.121 240.38L233.562 235.02C235.147 234.338 236.989 235.065 237.675 236.65L238.506 238.57C239.193 240.155 238.461 241.997 236.872 242.683Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.647 248.563L230.392 252.983C229.082 253.548 227.565 252.947 227 251.638L226.314 250.053C225.75 248.743 226.35 247.226 227.66 246.662L237.915 242.241C239.224 241.676 240.742 242.281 241.306 243.586L241.992 245.171C242.557 246.481 241.956 247.998 240.647 248.563Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M256.795 205.19L234.298 212.677C234.298 212.677 233.796 220.85 241.848 219.062C253.178 216.551 255.476 221.121 261.459 222.729C271.213 225.348 276.352 220.006 276.352 220.006",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.795 205.19L234.298 212.677C234.298 212.677 233.796 220.85 241.848 219.062C253.178 216.551 255.476 221.121 261.459 222.729C271.213 225.348 276.352 220.006 276.352 220.006",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M319.115 363.35L349.162 275.796H461.379",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M376.531 305.188L387.824 312.716L396.725 363.35",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M472.316 289.203L461.528 238.868C487.335 206.689 460.923 163.705 443.787 141.84C435.975 131.87 424.577 125.363 412.024 123.701C392.986 121.177 373.09 122.094 357.714 123.688C340.126 125.512 325.247 137.582 319.86 154.425C314.649 170.713 311.673 185.922 310.26 194.289H274.636V243.026H334.621L344.068 289.203H472.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M333.402 254.74H407.467L382.212 152.24H308.142L333.402 254.74Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M424.622 197.811L364.086 203.339C357.814 203.912 351.6 201.605 347.143 196.994C343.075 192.786 339.774 191.029 337.674 191.53C333.714 192.478 342.605 208.906 342.605 208.906H324.244C320.722 208.906 318.311 212.69 319.801 215.996C320.108 216.678 320.474 217.323 320.903 217.879C320.903 217.879 318.248 219.437 320.903 224.594C320.903 224.594 319.106 227.985 321.431 232.482C321.431 232.482 318.984 234.46 321.431 237.982C323.879 241.505 333.036 246.111 347.401 246.535C361.765 246.955 425.539 246.535 425.539 246.535L424.622 197.807V197.811Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M424.622 197.811L364.086 203.339C357.814 203.912 351.6 201.605 347.143 196.994C343.075 192.786 339.774 191.029 337.674 191.53C333.714 192.478 342.605 208.906 342.605 208.906H324.244C320.722 208.906 318.311 212.69 319.801 215.996C320.108 216.678 320.474 217.323 320.903 217.879C320.903 217.879 318.248 219.437 320.903 224.594C320.903 224.594 319.106 227.985 321.431 232.482C321.431 232.482 318.984 234.46 321.431 237.982C323.879 241.505 333.036 246.111 347.401 246.535C361.765 246.955 444.039 246.666 444.039 246.666C444.039 246.666 452.746 246.743 461.524 238.863",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M333.068 222.679C333.068 222.679 325.884 221.32 320.903 217.883",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M320.903 224.598C320.903 224.598 326.263 228.093 333.068 229.994",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M321.431 232.482C321.431 232.482 324.931 235.269 333.068 237.982",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M373.934 244.909V202.503",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M409.77 172.135L418.12 198.186",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M386.705 120.468L374.887 92.4665L356.025 90.9131L350.62 101.344L360.704 129.422L386.705 120.468Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M341.688 65.2056L337.037 100.874C337.037 100.874 359.895 109.219 361.562 101.9C363.232 94.5797 367.328 75.9437 367.328 75.9437L341.684 65.2101L341.688 65.2056Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M387.599 81.0149C387.608 77.2669 384.329 73.817 380.586 73.6364C383.345 66.7546 380.414 58.4187 374.707 53.6954C368.994 48.9675 361.083 47.518 353.731 48.4708C349.654 48.9991 345.599 50.2454 342.257 52.6387C338.916 55.032 336.346 58.6671 335.782 62.7402C335.222 66.8133 336.902 71.2566 340.347 73.4964C340.826 72.1868 341.3 70.8818 341.779 69.5723C343.309 73.4467 346.827 76.2735 350.665 77.8991C354.504 79.5247 358.69 80.1073 362.821 80.6717C362.018 83.1643 361.982 85.8331 361.62 88.4296C361.259 91.026 360.469 93.7219 358.532 95.4875C355.836 97.944 351.672 97.9304 348.164 96.9415C344.655 95.9526 341.386 94.1463 337.805 93.4554C336.572 96.3454 335.326 99.2806 334.915 102.396C334.504 105.512 335.023 108.885 337.015 111.319C340.022 114.999 345.337 115.573 350.083 115.871C353.849 116.106 357.823 116.3 361.182 114.575C365.368 112.426 367.644 107.743 368.683 103.15C369.721 98.5581 369.812 93.7761 371.094 89.2514C373.234 89.1701 375.37 89.0843 377.511 89.003C379.466 88.9263 380.667 88.8043 382.302 88.0457C385.192 86.7091 387.599 84.4648 387.608 81.0194L387.599 81.0149Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M370.435 87.5354C370.435 87.5354 374.693 77.0682 381.209 84.5099C387.725 91.9471 376.662 103.168 369.414 95.0584L370.439 87.5399L370.435 87.5354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M378.256 89.1023C376.043 89.6532 374.151 91.342 373.347 93.4779",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M347.586 85.3317C346.823 88.6327 348.435 91.8252 351.185 92.4619C353.935 93.0986 356.784 90.9402 357.547 87.6392C358.31 84.3383 356.698 81.1458 353.948 80.5091C351.198 79.8724 348.349 82.0308 347.586 85.3317Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333.994 82.1889C333.231 85.4898 334.843 88.6824 337.593 89.3191C340.343 89.9558 343.192 87.7973 343.955 84.4964C344.718 81.1955 343.106 78.0029 340.356 77.3662C337.606 76.7295 334.757 78.888 333.994 82.1889Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M347.586 85.3317C347.586 85.3317 345.928 83.3268 343.955 84.4918",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M357.552 87.6392L370.435 86.8445",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M362.668 121.534L386.14 112.737L390.263 122.161L368.47 140.3L362.501 130.05L356.775 138.309L352.959 124.78L354.838 118.359L362.668 121.534Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.927 147.936L132.881 104.672L112.927 88.9805L84.4286 134.028L112.927 147.936Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.48 59.6378C134.48 59.6378 144.532 62.0627 147.625 75.9979C150.718 89.9331 149.621 110.931 142.558 116.02C135.496 121.109 120.91 116.327 116.91 103.755C116.91 103.755 100.342 94.2907 105.205 81.0916C110.068 67.8924 134.475 59.6333 134.475 59.6333L134.48 59.6378Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4903 214.343C23.4903 214.343 41.0922 159.853 69.9967 135.442L75.4787 235.232L23.4858 214.339L23.4903 214.343Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1471 269.781H22.9529L4.16341 194.054H98.1471V269.781Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8138 363.35H156.344L133.274 253.561L146.6 211.263C150.781 197.987 148.799 183.542 141.204 171.883L124.347 146.013C118.391 136.873 108.786 130.714 97.9846 129.196C94.6249 128.722 88.7952 128.813 82.7714 129.242C74.5981 129.82 68.1724 136.476 67.8111 144.662L63.6793 237.323L44.7815 266.521C33.0589 284.629 26.8228 305.744 26.8228 327.315V363.35H26.8138Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1893 235.431H59.5927L57.3349 245.375H84.1893C86.9348 245.375 89.161 243.148 89.161 240.403C89.161 237.657 86.9348 235.431 84.1893 235.431Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M208.473 194.009V232.482C208.473 232.482 192.339 242.715 148.307 247.903C125.706 250.567 103.837 238.858 93.5863 218.538L73.248 178.218C73.248 178.218 111.134 139.876 112.927 140.296C114.715 140.716 141.538 194.005 141.538 194.005H208.477L208.473 194.009Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.831 148.289C126.054 163.253 141.533 194.009 141.533 194.009H208.473V232.482C208.473 232.482 192.339 242.715 148.307 247.903C125.706 250.567 103.837 238.858 93.5863 218.538L73.248 178.218",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M141.533 194.009H126.139",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M119.479 97.8852L89.3145 149.675C81.5973 162.924 64.2257 166.794 51.6181 158.065C51.4059 157.916 51.1936 157.767 50.9769 157.618C36.423 147.363 36.852 125.593 51.7039 115.776C57.7052 111.811 64.2754 108.24 70.6153 106.325C90.3757 100.355 94.5572 80.8071 99.0909 70.945C103.625 61.0829 112.06 51.302 137.74 53.3205C163.416 55.339 167.873 77.1811 149.815 81.2316C131.942 85.2415 125.376 90.8634 125.376 90.8634C125.376 90.8634 122.568 77.7455 115.424 82.3695C104.428 89.4907 119.483 97.8852 119.483 97.8852H119.479Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M118.467 86.6233C120.459 88.4341 121.773 90.9718 122.112 93.6406",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M305.194 84.8264C311.875 68.6979 304.216 50.2074 288.088 43.5268C271.959 36.8461 253.469 44.5051 246.788 60.6337C240.107 76.7622 247.766 95.2527 263.895 101.933C280.023 108.614 298.514 100.955 305.194 84.8264Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M294.179 67.9646H280.759V54.5442H271.222V67.9646H257.797V77.5016H271.222V90.9266H280.759V77.5016H294.179V67.9646Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M203.56 351.157C221.017 351.157 235.169 337.018 235.169 319.575C235.169 302.133 221.017 287.993 203.56 287.993C186.102 287.993 171.951 302.133 171.951 319.575C171.951 337.018 186.102 351.157 203.56 351.157Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M223.582 317.539C223.582 316.961 223.537 316.392 223.456 315.841C222.638 310.485 218.01 306.381 212.424 306.381C208.812 306.381 205.601 308.097 203.56 310.761C201.519 308.101 198.313 306.381 194.696 306.381C189.11 306.381 184.481 310.485 183.664 315.841C183.578 316.396 183.538 316.961 183.538 317.539C183.538 323.703 187.258 331.104 203.56 339.692C219.861 331.104 223.582 323.703 223.582 317.539Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M185.425 323.034H193.553L199.112 317.476L206.147 326.412L210.844 320.027L213.404 323.034",
    stroke: "white",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M308.304 337.624L313.556 305.265H284.168L295.159 337.624H308.304Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M302.755 300.379V298.225C302.755 297.128 301.865 296.239 300.768 296.239H288.991C287.894 296.239 287.004 297.128 287.004 298.225V300.379H254.997V333.89C254.997 335.953 256.668 337.624 258.732 337.624H308.304V300.379H302.759H302.755Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M272.27 319.124L279.734 327.143L291.854 311.506",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M272.27 319.124L279.734 327.143L291.854 311.506",
    stroke: "black",
    strokeWidth: 4.06406,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M177.622 63.0427H216.678C220.651 63.0427 223.876 66.2669 223.876 70.2406V93.4284C223.876 97.4021 220.651 100.626 216.678 100.626H177.622C173.648 100.626 170.424 97.4021 170.424 93.4284V70.2406C170.424 66.2669 173.648 63.0427 177.622 63.0427Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.152 81.2226C207.235 81.2226 215.409 73.0832 215.409 63.0427C215.409 53.0022 207.235 44.8628 197.152 44.8628C187.069 44.8628 178.896 53.0022 178.896 63.0427C178.896 73.0832 187.069 81.2226 197.152 81.2226Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3853_31923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 47,
    width: 33,
    height: 32
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M197.152 78.9648C205.983 78.9648 213.142 71.8362 213.142 63.0427C213.142 54.2492 205.983 47.1206 197.152 47.1206C188.321 47.1206 181.162 54.2492 181.162 63.0427C181.162 71.8362 188.321 78.9648 197.152 78.9648Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3853_31923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.152 49.4733C192.402 49.4733 188.464 54.2824 188.153 60.4643L187.159 80.2563H207.15L206.156 60.4643C205.845 54.2779 201.907 49.4688 197.157 49.4688L197.152 49.4733Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.197 70.7238L197.152 68.6511L188.107 70.7238C185.673 71.2837 183.736 73.108 183.045 75.4968L181.081 85.8195H213.223L211.259 75.4968C210.564 73.108 208.626 71.2837 206.197 70.7238Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.152 74.2232C194.998 74.2232 193.251 72.4756 193.251 70.3217V63.0696H201.049V70.3217C201.049 72.4756 199.302 74.2232 197.148 74.2232H197.152Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.682 58.0348C203.397 57.9626 203.108 57.9897 202.842 58.0935C202.616 54.4991 200.155 52.0652 197.148 52.0652C194.14 52.0652 191.679 54.5036 191.453 58.0935C191.187 57.9897 190.898 57.9671 190.614 58.0348C189.769 58.2426 189.286 59.2179 189.534 60.2069C189.783 61.1958 190.668 61.8325 191.508 61.6202C191.643 61.5886 191.77 61.5299 191.887 61.4622C192.759 64.1174 194.782 66.1494 197.148 66.1494C199.514 66.1494 201.537 64.1174 202.408 61.4622C202.526 61.5344 202.648 61.5886 202.783 61.6202C203.628 61.828 204.513 61.1958 204.757 60.2069C205 59.2179 204.522 58.2426 203.677 58.0348H203.682Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.363 58.9967C194.208 58.4638 197.179 55.9396 198.958 53.6637C199.306 55.6822 201.103 58.0439 202.986 58.8748C202.986 58.8748 203.89 51.1305 197.152 51.0898C188.825 51.0402 191.363 58.9967 191.363 58.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.422 56.5629C191.232 57.9221 191.363 58.9968 191.363 58.9968C194.208 58.4639 197.179 55.9397 198.958 53.6638C199.306 55.6823 201.103 58.044 202.986 58.8749C202.986 58.8749 203.135 57.5563 202.86 56.0029",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M188.97 90.2717C188.97 91.8251 187.71 93.085 186.157 93.085C184.603 93.085 183.343 91.8251 183.343 90.2717C183.343 88.7184 184.603 87.4585 186.157 87.4585C187.71 87.4585 188.97 88.7184 188.97 90.2717Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M199.965 90.2717C199.965 91.8251 198.706 93.085 197.152 93.085C195.599 93.085 194.339 91.8251 194.339 90.2717C194.339 88.7184 195.599 87.4585 197.152 87.4585C198.706 87.4585 199.965 88.7184 199.965 90.2717Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M210.961 90.2717C210.961 91.8251 209.701 93.085 208.148 93.085C206.594 93.085 205.334 91.8251 205.334 90.2717C205.334 88.7184 206.594 87.4585 208.148 87.4585C209.701 87.4585 210.961 88.7184 210.961 90.2717Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3853_31923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477.302,
    height: 375.7,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageImg);
export default __webpack_public_path__ + "static/media/landingPageImg.579c994068ba5e7a233cc9d39c217ba1.svg";
export { ForwardRef as ReactComponent };